import { defineComponent as n, createBlock as r, openBlock as a, unref as l, mergeProps as p, withCtx as m, createElementVNode as i } from "vue";
import { RevIcon as d } from "@ds/components/Icon";
const f = /* @__PURE__ */ n({
  name: "IconSmartphoneFilled",
  __name: "IconSmartphoneFilled",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(o) {
    const t = o;
    return (c, e) => (a(), r(l(d), p(t, { "view-box": "0 0 24 24" }), {
      default: m(() => [...e[0] || (e[0] = [
        i("path", {
          "fill-rule": "evenodd",
          d: "M5.25 5.5A3.25 3.25 0 0 1 8.5 2.25h7a3.25 3.25 0 0 1 3.25 3.25v13a3.25 3.25 0 0 1-3.25 3.25h-7a3.25 3.25 0 0 1-3.25-3.25v-13m4.5 0a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 0 1.5h-3A.75.75 0 0 1 9.75 5.5M12 19a1 1 0 1 0 0-2 1 1 0 0 0 0 2",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
